import { render, staticRenderFns } from "./ListCardUi.vue?vue&type=template&id=1f928728&lang=pug&"
import script from "./ListCardUi.vue?vue&type=script&lang=js&"
export * from "./ListCardUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports